import { faFigma, faNodeJs, faDeploydog } from "@fortawesome/free-brands-svg-icons";

export const imageCards = [
  { title: "Дизайн", img: "./images/figma.jpg", imgWebp: "./images/figma.wepb", icon: faFigma },
  { title: "Верстка", img: "./images/TS.png", imgWebp: "./images/TS.webp", icon: faNodeJs},
  { title: "Деплой", img: "./images/Skills.jpg", imgWebp: "./images/Skills.webp", icon: faDeploydog },
];

export const stagesCard = [
  {
    key: "stages-1",
    title: "Знакомство и брифинг",
    list: [
      "Обсуждаем задачу, цели и требования",
      "Определяем структуру сайта и нужные технологии",
      "Фиксируем сроки и формат работы",
    ],
  },
  {
    key: "stages-2",
    title: "Дизайн / работа с макетом",
    list: [
      "Беру готовый дизайн (Figma/Sketch) или предлагаю собственное решение",
      "Согласовываю внешний вид, шрифты, цветовую палитру",
    ],
  },
  {
    key: "stages-3",
    title: "Верстка",
    list: [
      "Адаптивная, кроссбраузерная верстка под все устройства",
      "Чистый, валидный HTML5 + CSS3 (SCSS)",
      "SEO-дружественная семантика",
    ],
  },
  {
    key: "stages-4",
    title: "Функционал и интерактив",
    list: [
      "Подключение JavaScript / TypeScript / React",
      "Динамические элементы: модалки, формы, слайдеры, фильтры",
      "Анимации и плавные переходы",
    ],
  },
  {
    key: "stages-5",
    title: " Интеграции и доработки",
    list: [
      "Подключение API (Telegram, карты, внешние сервисы)",
      "Настройка форм обратной связи",
      "Оптимизация производительности",
    ],
  },
  {
    key: "stages-6",
    title: "Тестирование и деплой",
    list: [
      "Проверка на всех устройствах и браузерах",
      "Исправление багов",
      "Деплой на сервер / Vercel / Netlify / GitHub Pages",
    ],
  },
];